import { render, staticRenderFns } from "./event-item.vue?vue&type=template&id=02e464e4"
import script from "./event-item.vue?vue&type=script&lang=js"
export * from "./event-item.vue?vue&type=script&lang=js"
import style0 from "./event-item.vue?vue&type=style&index=0&id=02e464e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports